function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2984 0L0 0.0460419L0.00478971 53.6L34.352 53.4637L45.6 39.4283L32.8919 26.6867L32.6062 26.3996L32.895 26.115L43.466 15.7409L27.2984 0ZM14.2837 8.86325L27.2398 21.3235L27.5279 21.6L27.8195 21.3243L32.5038 16.9146L32.8001 16.6359L32.5055 16.3525L23.9163 8.11923L23.7924 8L23.6184 8.003L14.5671 8.18659L13.6001 8.20658L14.2837 8.86325ZM30.0909 45.2864L8.00496 23.8257L8 13.6L34.9347 39.7514L35.2 40.0105L34.9606 40.2918L30.7044 45.2613L30.413 45.6L30.0909 45.2864ZM19.2 45.5495L8 35.2L8 45.6L19.2 45.5495Z",
  transform: "translate(0.3601074 0.3600006)",
  id: "Fill-1",
  fill: "#0080FF",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgLogoSmall = function SvgLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "55px",
    viewBox: "0 0 47 55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-small.89bde8c5.svg";
export { ForwardRef as ReactComponent };